module.exports = __webpack_public_path__ + "img/passing.69d31c39.png";